/**
 * Barra fixa inferior: mostra após scroll > 700px (remove translate-y-b-hidden).
 * Antes: theme.menuFlutuante em theme.js.
 */
(function () {
  "use strict";

  var SCROLL_THRESHOLD = 700;

  function updateVisibility(container) {
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop > SCROLL_THRESHOLD) {
      container.classList.remove("translate-y-b-hidden");
    } else {
      container.classList.add("translate-y-b-hidden");
    }
  }

  function bind(container) {
    if (!container || container.dataset.teamdropMenuFloatInit === "1") return;
    container.dataset.teamdropMenuFloatInit = "1";

    function onScroll() {
      updateVisibility(container);
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    updateVisibility(container);
  }

  function boot(root) {
    (root || document).querySelectorAll(".menu-flutuante").forEach(bind);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event.target) return;
    var el = event.target.querySelector(".menu-flutuante");
    if (el) {
      delete el.dataset.teamdropMenuFloatInit;
      bind(el);
    }
  });
})();
